type Props = {
  subtitle: string
  title: string
}

export function SectionHeading({ subtitle, title }: Props) {
  return (
    <div className="text-center mb-14 animate-on-scroll">
      <p className="text-brand-cyan text-sm font-medium tracking-widest uppercase mb-3">
        {subtitle}
      </p>
      <h2 className="text-2xl md:text-3xl font-bold text-brand-navy mb-3 relative inline-block">
        {title}
        <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-12 h-1 bg-brand-cyan rounded-full" />
      </h2>
    </div>
  )
}
